<template>
    <b-modal
        v-model="modalShow"
        size="md"
        title="翻訳を修正"
        hide-footer
        @hidden="close">
        <div class="mb-3">
            <div v-if="transAnswer !== null">
                <div class="modificationItem mb-3">修正中の項目:&nbsp;<span>{{ transAnswer.title }}</span></div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>日本語<span class="small text-muted">（日本語を修正して再翻訳を行うことができます）</span></label>
                            <div class="d-flex align-items-center">
                                <textarea
                                    v-if="transAnswer.interview_question_type_id === types.multiInput"
                                    v-model="transAnswer.content"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.content }">
                                </textarea>
                                <input
                                    v-else
                                    v-model="transAnswer.content"
                                    type="text"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.content }">
                                <button
                                    class="ml-2 customFormBtn"
                                    @click="onClickBtnTranslation">
                                    再翻訳
                                </button>
                            </div>
                            <div
                                v-if="errors.content"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.content[0] }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>英語<span class="small text-muted">（英語を直接修正することができます）</span></label>
                            <textarea
                                v-if="transAnswer.interview_question_type_id === types.multiInput"
                                v-model="transAnswer.content_en"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.content_en }">
                            </textarea>
                            <input
                                v-else
                                v-model="transAnswer.content_en"
                                type="text"
                                class="form-control">
                            <div
                                v-if="errors.content_en"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.content_en[0] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="key !== null && transProfile !== null">
                <div class="modificationItem mb-3">修正中の項目:&nbsp;<span>{{ profileTitle }}</span></div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>日本語<span class="small text-muted">（日本語を修正して再翻訳を行うことができます）</span></label>
                            <div class="d-flex align-items-center">
                                <input
                                    v-model="transProfile[key]"
                                    type="text"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.value }">
                                <button
                                    class="ml-2 customFormBtn"
                                    @click="onClickBtnTranslation">
                                    再翻訳
                                </button>
                            </div>
                            <div
                                v-if="errors.value"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.value[0] }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>英語<span class="small text-muted">（英語を直接修正することができます）</span></label>
                            <input
                                v-model="transProfile[key + '_en']"
                                type="text"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.value_en }">
                            <div
                                v-if="errors.value_en"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.value_en[0] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <b-button
                class="nextButton"
                :disabled="inProgress"
                @click="handleOk">
                修正内容を反映する
            </b-button>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                types: constants.interview_question_types,
                inProgress: false,
                modalShow: false,
                user: null,
                key: null,
                profileTitle: null,
                transProfile: null,
                transAnswer: null,
                errors: {},
            }
        },

        created: function() {
            bus.$on('open-modal-user-interview-trans-modification', this.open)
            bus.$on('user-interview-trans-completed', this.close)
        },

        beforeDestroy: function() {
            bus.$off('open-modal-user-interview-trans-modification')
            bus.$off('user-interview-trans-completed')
        },

        methods: {
            /**
             * モーダル表示
             * @param {object} params
             */
            open: function (params) {
                this.modalShow = true
                this.profileTitle = null
                this.key = params.key
                this.transProfile = params.transProfile ? { ...params.transProfile } : null
                this.transAnswer = params.transAnswer ? { ...params.transAnswer } : null

                if (this.key && this.transProfile) {
                    if (this.key === 'last_name_kana') {
                        this.profileTitle = 'セイ'
                    }
                    else if (this.key === 'first_name_kana') {
                        this.profileTitle = 'メイ'
                    }
                    else if (this.key === 'sex') {
                        this.profileTitle = '性別'
                    }
                    else if (this.key === 'birthday') {
                        this.profileTitle = '生年月日'
                    }
                    else if (this.key === 'height') {
                        this.profileTitle = '身長'
                    }
                    else if (this.key === 'weight') {
                        this.profileTitle = '体重'
                    }
                    else if (this.key === 'blood') {
                        this.profileTitle = '血液型'
                    }
                    else if (this.key === 'body_temperature') {
                        this.profileTitle = '体温'
                    }
                }
            },

            /**
             * モーダル非表示
             */
            close: function() {
                this.modalShow = false
            },

            /**
             * 「再翻訳」ボタン押下時
             * @param {object} e
             */
            onClickBtnTranslation: async function(e) {
                e.preventDefault()

                if (this.inProgress) return
                this.inProgress = true

                if (this.transAnswer !== null) {
                    const endpoint = constants.user.interview_trans_answers.endpoint.base
                    const params = {
                        content: this.transAnswer.content,
                    }
                    await axios.post(`${endpoint}/${this.transAnswer.id}/translate`, params)
                        .then(({data}) => {
                            this.errors = {}
                            this.transAnswer.content = data.data.content
                            this.transAnswer.content_en = data.data.content_en
                        })
                        .catch(({response}) => {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        })
                }
                else if (this.key !== null && this.transProfile !== null) {
                    const endpoint = constants.user.interview_trans_profiles.endpoint.base
                    const params = {
                        key: this.key,
                        value: this.transProfile[this.key],
                    }
                    await axios.post(`${endpoint}/${this.transProfile.id}/translate`, params)
                        .then(({data}) => {
                            this.errors = {}
                            this.transProfile[this.key] = data.data[this.key]
                            this.transProfile[this.key + '_en'] = data.data[this.key + '_en']
                        })
                        .catch(({response}) => {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        })
                }

                this.inProgress = false
            },

            /**
             * 「修正内容を反映する」ボタン押下時
             * @param {object} e
             */
            handleOk: async function(e) {
                e.preventDefault()

                if (this.inProgress) return
                this.inProgress = true

                if (this.transAnswer !== null) {
                    const endpoint = constants.user.interview_trans_answers.endpoint.base
                    const params = {
                        content: this.transAnswer.content,
                        content_en: this.transAnswer.content_en,
                    }
                    await axios.put(`${endpoint}/${this.transAnswer.id}`, params)
                        .then(({data}) => {
                            this.errors = {}
                            bus.$emit('user-interview-trans-answer-modified', this.transAnswer)
                            this.close()
                        })
                        .catch( ({response}) => {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        })
                }
                else if (this.key !== null && this.transProfile !== null) {
                    const endpoint = constants.user.interview_trans_profiles.endpoint.base
                    const params = {
                        key: this.key,
                        value: this.transProfile[this.key],
                        value_en: this.transProfile[this.key + '_en'],
                    }
                    await axios.put(`${endpoint}/${this.transProfile.id}`, params)
                        .then(({data}) => {
                            this.errors = {}
                            bus.$emit('user-interview-trans-profile-modified', this.transProfile)
                            this.close()
                        })
                        .catch( ({response}) => {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        })
                }

                this.inProgress = false
            },
        },
    }
</script>

<style lang="scss" scoped>
.modificationItem {
    padding: 6px 9px;
    font-size: 12px;
    background-color: #F5F5F5;
    border: 1px solid #D9D9D9;
    border-radius: 9px;

    span {
        font-size: 13px;
        font-weight: bold;
    }
}

.nextButton {
    display: block;
    width: 210px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background-color: #CF798A;
    border: none;
    border-radius: 8px;
    cursor: pointer;
}

.customFormBtn {
    display: block;
    width: 70px;
    height: 37px;
    line-height: 37px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    background-color: #75A4FF;
    border: none;
    border-radius: 6px;
    cursor: pointer;
}
</style>
